webModule.controller('NavbarController', ['$scope', '$location', function ($scope, $location) {
    $scope.showNavBar = function() {
        return ($location.path().indexOf('login') <= 0);
    };

    $scope.getClass = function (path) {
        return $location.path().substr(0, path.length) == path;
    };
}]);